<div class="tw-flex tw-rounded-md tw-items-center tw-justify-center tw-p-3 tw-bg-gradient-to-r
tw-from-yellowLight tw-via-white tw-to-yellowLight ">
    <div class="tw-flex tw-font-semibold tw-text-sm tw-items-center tw-flex-wrap tw-justify-center tw-leading-loose">&#8377;1500 Instant
        Discount with
        EasyEMI on <img src="/assets/images/HDFC_Bank_Logo.svg.png" alt="" class="tw-w-32 tw-px-2"> Cards
    </div>
</div>